import { getBrandName } from './brand.helpers'

const objectHasTrueValue = (obj) => {
  return Object.values(obj).some((value) => value === true)
}

const createCashbackTrackingUrl = (url, authId) => {
  return `${url}${authId}&sid=${getBrandName()}`
}

export { objectHasTrueValue, createCashbackTrackingUrl }
